import React from 'react'
import TagBrandPage from './TagBrandPage'

const TagBrandPageContainer = () => {
    return (
        <div className='TagBrandPageContainer'>
            <TagBrandPage />
        </div>
    )
}

export default TagBrandPageContainer